import React from 'react';

export const Hero = ({ setActiveSection, goToPortfolio, shopifyLinks }) => (
  <section className="bg-slate-950 text-white py-20">
    <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-[1fr_1.65fr] gap-10 items-center">
      <div>
        <h1 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">Real Estate Photography + Construction Mapping</h1>
        <p className="mb-6 text-base md:text-lg text-slate-300">Proudly serving the south Charlotte area.</p>
        <div className="flex flex-wrap gap-4">
          <a
            href={shopifyLinks?.storefront}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-8 py-5 rounded-3xl bg-sky-600 hover:bg-sky-700 text-white font-semibold text-xl shadow-2xl transition-all hover:scale-105 flex-1 min-w-[280px]"
          >
            See our store and products on Shopify!
          </a>
          <button onClick={() => goToPortfolio('realestate')} className="inline-flex items-center gap-3 px-8 py-5 rounded-3xl border-2 border-white hover:bg-white hover:text-slate-900 text-white font-semibold text-xl shadow-2xl transition-all hover:scale-105 flex-1 min-w-[280px]">👀 Real Estate Portfolio</button>
          <button onClick={() => goToPortfolio('mapping')} className="inline-flex items-center gap-3 px-8 py-5 rounded-3xl border-2 border-white hover:bg-white hover:text-slate-900 text-white font-semibold text-xl shadow-2xl transition-all hover:scale-105 flex-1 min-w-[280px]">🗺️ Construction Mapping Portfolio</button>
        </div>
      </div>
      <div className="block rounded-3xl overflow-hidden border border-slate-700 shadow-2xl aspect-[4/3] md:aspect-[16/10] lg:aspect-video">
        <iframe src="https://app.cloudpano.com/tours/uqbpXhGnA" className="w-full h-full" allowFullScreen title="360° Virtual Tour" allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; gyroscope; accelerometer; magnetometer" />
      </div>
    </div>
  </section>
);
